<script setup lang="ts">
// @ts-expect-error raison: lib externe mal typée
import { ref, defineProps, watch, defineEmits, PropType } from 'vue';
import { formatAmount } from '@/utils/formatters';

interface StartupInfosCheckout {
    adresses: any[];
}

const props = defineProps({
    modelValue: { type: Number, default: null },
    startupInfos: { type: Object as PropType<StartupInfosCheckout>, default: null },
    adresse: { type: Object, default: null },
});
const emit = defineEmits(['update:modelValue', 'onEditAdresse']);
const modeLivraison = ref(-1);

watch(props, () => {
    if (props.modelValue) {
        modeLivraison.value = props.modelValue;
    }
}, { deep: true });

watch(modeLivraison, () => {
    emit('update:modelValue', modeLivraison.value);
}, { deep: true });

function onEditAdresse(adresse?: any) {
    emit('onEditAdresse', adresse);
}

</script>
<style scoped>
.livraison-item-disabled {
    opacity: 0.5;
    pointer-events: none;
}
</style>
<template>
    <h2 class="secondary-font mb-4">Mode de livraison</h2>

    <h6 class="secondary-font mb-3">
        Livraison : sam. 14 juin - mar. 17 juin 2026
    </h6>
    <h6 class="secondary-font mb-4 text-grey-700">
        Abidjan Cocody Faya Nouveau Goudro<br/>
        +225 08 07 07 07 07
    </h6>

    <div class="card-check bg-white-50 widget flex my-2 pt-5 pb-4 px-6" :class="{'active': modeLivraison === -1}">
        <label class="s20" for="mode_livraison_0">
            <div class="s1 mt-1"><input class="" type="radio" name="super" id="mode_livraison_0" :value="-1" v-model="modeLivraison" /></div>
            <h5 class="s11 pl-2 secondary-font">Retrait en point relais <br class="mb-2"/>
                <span class="secondary-font text-grey-600">Adresse de la collectivité</span>
            </h5>
            <h4 class="s5 text-right secondary-font">{{ formatAmount(0) }} F</h4>
            <div class="s3 text-right">
                <img src="/public/icons/icon-livraison-relais.svg" class="size-base" alt="" />
            </div>
        </label>
    </div>
    <div class="card-check bg-white-50 widget flex my-2 pt-5 pb-4 px-6" :class="{'active': modeLivraison === 1, 'livraison-item-disabled': !props.adresse}">
        <label class="s20" for="mode_livraison_1">
            <div class="s1 mt-1"><input class="" type="radio" name="super" id="mode_livraison_1" :value="props.adresse?.id" v-model="modeLivraison" /></div>
            <h5 class="s11 pl-2 secondary-font" v-if="props.adresse">{{ props.adresse.libelle }} <br class="mb-2"/>
                <span class="secondary-font text-grey-600">{{ props.adresse.adresse }} <br/>{{ props.adresse.telephone }}</span>
                <br/>
                <a @click="onEditAdresse(props.adresse)" style="cursor: pointer"><h6 class="text-black mt-1">Modifier</h6></a>
            </h5>
            <h5 class="s11 pl-2 secondary-font" v-if="!props.adresse">Livraison à domicile <br class="mb-2"/>
                <span class="secondary-font text-grey-600">
                    Aucune adresse définie
                </span><br/>
                <a @click="onEditAdresse()" style="cursor: pointer; opacity: 1;"><h6 class="text-black mt-1">Modifier</h6></a>
            </h5>
            <h4 class="s5 text-right secondary-font">{{ props.adresse ? formatAmount(2000) : '-' }} F</h4>
            <div class="s3 text-right">
                <img src="/public/icons/icon-livraison-domicile.svg" class="size-base" alt="" />
            </div>
        </label>
    </div>
</template>